/* 2026-11-01 Arboroot : haut de page produit façon BioRoot Labs (prix du pack choisi sous le titre, pays de livraison, « Ends in »). */
(function () {
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  /* prix, prix barré et % du pack choisi, recopiés dans le bloc prix sous le titre */
  $$('[data-ar-pp]').forEach(function (pp) {
    var root = pp.closest('.ar-pm') || document, f = root.querySelector('[data-ar-bb]');
    if (!f) return;
    var off = pp.querySelector('[data-pp-off]');
    function paint() {
      var o = f.querySelector('.ar-opt.is-on') || f.querySelector('.ar-opt');
      if (!o) return;
      pp.querySelector('[data-pp-price]').textContent = (o.dataset.plan && o.dataset.planPrice) || o.dataset.price;
      pp.querySelector('[data-pp-cmp]').textContent = o.dataset.cmp || '';
      off.hidden = !o.dataset.off;
      if (o.dataset.off) off.textContent = off.dataset.tpl.replace('{p}', o.dataset.off);
    }
    $$('.ar-opt', f).forEach(function (o) { o.addEventListener('click', function () { setTimeout(paint, 0); }); });
    paint();
  });

  /* drapeau du pays de livraison (le code pays vient de Shopify) */
  var cc = ((window.Shopify && Shopify.country) || 'US').toUpperCase();
  var flag = /^[A-Z]{2}$/.test(cc) ? String.fromCodePoint(127397 + cc.charCodeAt(0), 127397 + cc.charCodeAt(1)) : '';
  $$('[data-ar-flag]').forEach(function (el) { el.textContent = flag; });

  /* « Ends in » : même minuit que le bandeau */
  var cds = $$('[data-ar-cd2]');
  if (cds.length) {
    var p = function (x) { return (x < 10 ? '0' : '') + x; };
    var tick = function () {
      var now = new Date(), end = new Date(now); end.setHours(24, 0, 0, 0);
      var s = Math.max(0, Math.floor((end - now) / 1000)), t = p(Math.floor(s / 3600)) + ':' + p(Math.floor(s % 3600 / 60)) + ':' + p(s % 60);
      cds.forEach(function (el) { el.textContent = t; });
    };
    tick(); setInterval(tick, 1000);
  }
  /* [2026-11-01] contrôle UX : « Shop Now » de la barre collante descendait en haut du bloc (l'image) → descend aux packs, sous l'en-tête */
  var stb = document.querySelector('[data-ar-sticky] a[href="#ar-buy"]'), packs = document.querySelector('.ar-pm .ar-v2-ship') || document.querySelector('.ar-pm [data-ar-bb]');
  if (stb && packs) stb.addEventListener('click', function (e) {
    e.preventDefault();
    var hd = document.querySelector('.ar-hd'), off = (hd ? hd.getBoundingClientRect().height : 0) + 12;
    window.scrollTo({ top: packs.getBoundingClientRect().top + window.scrollY - off, behavior: 'smooth' });
  });
})();
